import { get, post } from "@/utils/api";
import { USE_QUERY_PARAM_ALIAS, USE_STATIC_CONFIG } from "@/config";
import type { Service } from "@/types/Service";
import type { FormConfig } from "@/types/FormConfig";
import type {
  SubmissionParams,
  SubmissionResponse,
  RetrieveAvailableDatesResponse,
  BankDetailsParams,
} from "@/types/Payment";

type PaymentTokenResponse = {
  message: string;
  status: string;
};

function getFormAlias(): string | null {
  if (USE_QUERY_PARAM_ALIAS) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("form");
  }

  const pathname = window.location.pathname;
  const alias = pathname.split("/").filter(Boolean).pop();

  return alias ?? null;
}

export const productionService: Service = {
  name: "production",
  getFormConfig: async () => {
    if (USE_STATIC_CONFIG) {
      if (!window.__FORM_CONFIG__) {
        throw new Error("Static form configuration not found");
      }
      return window.__FORM_CONFIG__;
    }

    const alias = getFormAlias();

    if (!alias) {
      throw new Error("Form alias not found");
    }

    return get<FormConfig>(`/api/form-config/${alias}`);
  },
  getPaymentToken: async () => {
    const response = await post<PaymentTokenResponse>("/api/payment/token");

    return {
      token: response.message,
    };
  },
  sendSubmission: async (params: SubmissionParams) => {
    return post<SubmissionResponse>(`/api/data/save-with-payment`, params);
  },
  validateBankDetails: async (params: BankDetailsParams) => {
    return post<boolean | string>(`/api/validate-bank-details`, params);
  },
  getRetrieveAvailableDates: async (date: string) => {
    return get<RetrieveAvailableDatesResponse>(`/api/dd-calc?date=${date}`);
  },
  sendGiftAid: async (submissionId: string) => {
    const data = {
      missing_components: {
        gift_aid: true,
      },
    };

    return post<void>(
      `/api/data/submission/${submissionId}/missing-components/gift-aid`,
      data,
    );
  },
  sendSignUpFrontline: async (submissionId: string) => {
    const data = {
      missing_components: {
        sign_up_frontline: true,
      },
    };

    return post<void>(
      `/api/data/submission/${submissionId}/missing-components/sign-up-frontline`,
      data,
    );
  },
};
